import React from "react";
import SubmittedCopyright from "../../sumitted_copyright/SubmittedCopyright";

const CorrectionFormCopyright = () => {
  const applicationPath = {
    copyright: "/admin/correction-form-copyright",
    agreement: "/admin/correction-form-agreement",
  };
  const pageTitle = "সংরক্ষিত নথি";
  return (
    <SubmittedCopyright
      fileStatus={2}
      applicationPath={applicationPath}
      pageTitle={pageTitle}
    />
  );
};

export default CorrectionFormCopyright;
